export const MerchantDataReducer = (state = {}, action) => {
    switch (action.type) {
        case 'MERCHANT_ALL_DATA':
            return action.merData;
        default: return state;
    }
}